import { render, staticRenderFns } from "./NewFeatureUpload.vue?vue&type=template&id=71c80c90&"
import script from "./NewFeatureUpload.vue?vue&type=script&lang=js&"
export * from "./NewFeatureUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports